import React from 'react';
import parse, { attributesToProps } from 'html-react-parser';

class QuestionComponent extends React.Component {
  
  render() {
  console.log("this.props.templatePath", this.props.questionName,this.props.questionTable,this.props.questionTables)
    return (
      <span>
        <div className="col s12 l10">
          <h5>{this.props.questionText}</h5>
         

          <div className="following-cities drop_c_width">
            {this.props.QuestionOptions}
            
            {this.props.po}
          </div>
          <div className="col s12 l10" style={{marginBottom:"25px"}}>
          {this.props.templatePath !== "" ? (
              <p>click here to view  <a href={this.props.templatePath} download target="_blank" > {this.props.attachTemplateText && this.props.attachTemplateText.length > 0 ? this.props.attachTemplateText : "template file"}</a></p>
              ): ""}
              </div>
         
          <div className="col s12 l10">
          {this.props.questionLabel}
          </div>
          <div className={this.props.questionLabel ? "outer joc":""}>
          <div className="joc col s12 ">
          {/* {this.props.questionLabel} */}
          </div>
          <div className="col s12 " style={{marginLeft: "30px",paddingTop: "20px"}}>
          {this.props.questionFile}
          </div>
          <div className = "jock col s12 ">
          {/* {this.props.questionName}
          {this.props.questionTable}
          {this.props.questionTables} */}
          <table>
            <tr style={{borderBottom:"0px"}}>
              <td>{this.props.questionName}</td>
              <td> {this.props.questionTable}</td>
              <td>{this.props.questionTables}</td>
            </tr>
          </table>
          </div>
          </div>
          </div>
          
          <div className="col s12 l10" style={{marginLeft:"155px",marginTop:"60px"}}>
          {this.props.questionNotesText}
          </div>
          <div style={{marginLeft:"155px"}}>{this.props.questionInput} </div>
          
          
          
        
      </span>
    );
  }
}
export default QuestionComponent;
